@if (badge()) {
  <span class="tw-block tw-w-full tw-min-w-0 tw-max-w-full">
    <span
      class="tw-inline-flex tw-items-center tw-justify-center tw-max-w-full tw-min-w-0 tw-px-2.5 tw-py-0.5 tw-rounded-md tw-text-xs tw-font-medium tw-font-inter tw-h-[22px]"
      [ngClass]="resolvedHostNgClass()"
    >
      <span
        #truncation="appTruncationDetector"
        appTruncationDetector
        class="tw-truncate tw-min-w-0 tw-max-w-full tw-text-center tw-font-medium"
        [ngxTippy]="truncation.isTruncated() ? resolvedTooltipText() : null"
        [tippyProps]="tippyProps()"
      >{{ text() }}</span>
    </span>
  </span>
} @else {
  <span
    #truncation="appTruncationDetector"
    appTruncationDetector
    class="tw-truncate tw-min-w-0 tw-max-w-full tw-font-medium"
    [ngClass]="resolvedHostNgClass()"
    [ngxTippy]="truncation.isTruncated() ? resolvedTooltipText() : null"
    [tippyProps]="tippyProps()"
  >
    <ng-content>{{ text() }}</ng-content>
  </span>
}
